import { TemplateRef } from "@angular/core";

export enum ColumnType {
  numeric = 'numeric',
  category = 'category',
  text = 'text',
  date = 'date',
  button = 'button'
}

export enum InputType {
  numeric = 'numeric',
  select = 'select',
  text = 'text',
  date = 'date',
  multiselect = 'multiselect',
  template = 'template'
}

export class TableColumnModel {
  readonly name!: string;
  readonly label!: string;
  readonly type!: ColumnType;
  readonly displayField?: string;

  //numeric type fields 
  readonly isInteger?: boolean;
  readonly maxFractionDigits?: number;
  readonly minValue?: number;
  readonly maxValue?: number;

  //filter and sort related properties
  readonly hideFilter?: boolean;
  readonly filterField?: string;
  readonly sortField?: string;
  readonly disableSort?: boolean;

  readonly link?: string;
  readonly dateFormat?: string;
  calendarFormat?: string;
  readonly dateOnly?: boolean;
  readonly currency?: string;
  readonly colSize?: string;
  readonly widthPercent?: number;
  matchMode?: string;
  matchModeOptions?: { label: string, value: string }[];
  dateSelectionMode?: string;
  dateAugmented?: boolean;
  filterDates?: Date[];
  readonly showIcon?: boolean;
  readonly iconAlignment?: 'left' | 'center' | 'right';
  readonly staticList?: string[];

  inputType?: InputType;
  inputSelectOptions?: any[];
  inputPlaceholder?: string;
  required?: boolean;
  checkPositive?: boolean;
  greaterThanValue?: number;
  editTemplate?: TemplateRef<any>;
}

export class IconModel {
  title: string;
  name?: string;
  label?: string;
  order: number;
  glyph?: string;
  matIcon?: boolean;
  imageUrl?: string;
  primeClass?: string;
  action?: string;
  severity?: string;
}

export class IconColumnModel {
  icons!: IconModel[];
  sortNumber!: number;
  textValue!: string;
}

export type ActionEventType = 'init' | 'save' | 'cancel' | 'delete';

export class ActionButtonEvent {
  entry: any;
  action?: ActionEventType;
  customAction?: string;
}